export default __webpack_public_path__ + "static/media/photo--lg--120.11a73458.jpg";